import React, { useContext, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import 'assets/styles/common.scss';
import AbsolutLogo from 'assets/images/absolute-logo.svg';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ReusableButton from 'components/commom/Button';
import { useNavigate } from 'react-router-dom';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { loginUsers } from 'store/login/LoginAction';
import CheckValidation from 'utils/validate';
import LabelWithInput from 'components/commom/LabelWithInput';
import { ClearTokenRedirectLogin, enCodeBase64 } from 'utils/general';
import { dashboard, otp } from 'routes/AppUrls';
import LocalStorageManager from 'managers/LocalStorageManger';
import CommonToast from 'components/commom/CommonToast';
import CommonModal from 'components/commom/Modal';
import { MuiOtpInput } from 'mui-one-time-password-input';
import styled from 'styled-components';
import { adminOtpVerifyCallAPI } from 'store/AdminOtpVerify/AdminOtpVerifyAction';
import {
  basicDetailsValue,
  LOGIN_DETAILS,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';

const CustomMuiOtpInput = styled(MuiOtpInput)({
  '& .MuiOutlinedInput-root': {
    border: 'none',
    borderBottom: '1px solid #864629',
    borderRadius: '0px',
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: '48px',
    color: '#3C3C3C',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
    borderRadius: '0px',
  },
});

const Login = () => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const { locale } = useContext(LocaleContext);
  const [isPassVisible, setIsPassVisible] = useState(false);
  const [formValue, setformValue] = useState({
    email: '',
    password: '',
  });
  const [otpModal, setOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState('');

  const loginReducer = useSelector((state) => state?.loginReducer?.loading);
  const otpVerifyLoader = useSelector(
    (state) => state?.adminOtpVerifyReducer?.loading
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const hanldeLogin = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        dispatch(basicDetailsValue(LOGIN_DETAILS, formValue));
        navigate(otp(locale));
        // hanldeOtpLogin();
        // navigate(dashboard(locale));
        // LocalStorageManager.setItem('token', res?.data?.key);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const error = CheckValidation(formValue);
    setIsError(error);
    if (error.submit) {
      let body = {
        username: formValue?.email,
        password: enCodeBase64(formValue?.password),
      };
      dispatch(loginUsers(body, external));
    }
  };

  const hanldeOtpLogin = () => {
    setOtpModal(true);
  };

  const handleCloseModal = () => {
    setOtpModal(false);
  };

  const handleOtpVerify = () => {
    if (otpValue.length === 6) {
      const external = {
        run: true,
        handleFunction: (res) => {
          LocalStorageManager.setItem('token', res?.data?.key);
          navigate(dashboard(locale));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {},
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      let body = {
        username: formValue?.email,
        otp: otpValue,
        fcm_token: 'string',
      };
      dispatch(adminOtpVerifyCallAPI(body, external));
    } else {
      showToast('Please enter 6 digit otp', 'error');
    }
  };

  const handleChange = (e) => {
    setOtpValue(e);
  };

  return (
    <>
      <Row className="m-0 p-0 landing-image">
        <Row className="m-0 p-0 flex justify-content-center">
          <Col
            xs={12}
            sm={10}
            md={10}
            lg={6}
            xl={6}
            xxl={4}
            className="bg-light-100 m-sm-auto m-lg-auto login-card p-0"
          >
            <div class="py-60 px-40">
              <div className="d-flex">
                <Image src={AbsolutLogo} alt={'icon'} />
              </div>
              <div className="main-heading pt-24 family_outfit_semiBold_600">
                Login
              </div>
              <div className="pt-12 fs-20 family_outfit_regular_400 lh-26 fc-6B788E">
                Please enter your details to sign in
              </div>
              <Row>
                <Col sm={12} className="">
                  <div className="pt-40">
                    <LabelWithInput
                      label="E-mail Address"
                      placeholder="Enter your mail"
                      name="email"
                      type="text"
                      value={formValue?.email}
                      onChange={handleInputChange}
                      errorText={
                        isError &&
                        isError?.email?.error &&
                        isError?.email?.errorMessage
                      }
                    />
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="pt-16">
                    <LabelWithInput
                      label="Password"
                      placeholder="Enter your password"
                      name="password"
                      value={formValue?.password}
                      type={isPassVisible ? 'text' : 'password'}
                      onChange={handleInputChange}
                      InputProps={{
                        endAdornment: (
                          <>
                            {isPassVisible ? (
                              <VisibilityOutlinedIcon
                                sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                                onClick={() => setIsPassVisible(!isPassVisible)}
                              />
                            ) : (
                              <VisibilityOffOutlinedIcon
                                sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                                onClick={() => setIsPassVisible(!isPassVisible)}
                              />
                            )}
                          </>
                        ),
                      }}
                      errorText={
                        isError &&
                        isError.password.error &&
                        isError.password.errorMessage
                      }
                    />
                  </div>
                </Col>
                {/* <Col
                  xs={12}
                  md={12}
                  className="d-flex justify-content-end pt-20"
                >
                  <p className="fs-20 lh-208 family_outfit_medium_500 fc-2C2C2C p-0 m-0 underline underline-offset-1 ...">
                    Forgot password?
                  </p>
                </Col> */}
              </Row>
              <div className="pt-28">
                <ReusableButton
                  fullWidth={true}
                  variant="outlined"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="12px 24px"
                  borderRadius="8px"
                  height="48px"
                  bgColor="#2C2C2C"
                  brColor=""
                  fontFamily="outfit_semiBold"
                  onClick={() => {
                    !loginReducer && hanldeLogin();
                  }}
                  loading={loginReducer}
                >
                  Login
                </ReusableButton>
              </div>
            </div>
          </Col>
        </Row>
      </Row>
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={otpModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="main-heading pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Verification
                </div>
                <div className="mt-16 fs-16 family_outfit_regular_400 lh-208 fc-998A7B pt-12">
                  Enter the OTP has been sent on your registered email address.
                </div>
                <div className="pt-20">
                  <CustomMuiOtpInput
                    length={6}
                    value={otpValue}
                    onChange={handleChange}
                  />
                </div>
                {/* <div className="fs-18 family_outfit_regular_400 lh-27 fc-7F7F7F pt-40 flex justify-center">
                  Did not receive the OTP?
                </div>
                <div
                  className="fs-20 family_outfit_medium_500 fc-3C3C3C lh-30 pt-04 flex justify-center cursor-pointer ..."
                  onClick={() => hanldeResend()}
                >
                  Resend
                </div> */}
              </Col>
              <Col xs={12} md={12} className="mt-5 flex">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0 w-full"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseModal()}
                  >
                    Cancel
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={true}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !otpVerifyLoader && handleOtpVerify();
                    }}
                    loading={otpVerifyLoader}
                  >
                    Verify
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </>
  );
};
export default Login;
